import * as actionTypes from "../actionTypes";

export const saveFinanceValues = (payload) => ({
  type: actionTypes.SAVE_FINANCE_VALUES,
  payload,
});

export const getSalesData = (payload) => ({
  type: actionTypes.GET_SALES_DATA,
  payload,
});

export const saveSalesData = (payload) => ({
  type: actionTypes.SAVE_SALES_DATA,
  payload,
});

export const getOtherIncomeDataOptions = (payload) => ({
  type: actionTypes.GET_OTHER_INCOME_DATA_OPTIONS,
  payload,
});

export const saveOtherIncomeDataOptions = (payload) => ({
  type: actionTypes.SAVE_OTHER_INCOME_DATA_OPTIONS,
  payload,
});
export const postOtherIncomeData = (payload) => ({
  type: actionTypes.POST_OTHER_INCOME_DATA,
  payload,
});
export const saveOtherOptionsData = (payload) => ({
  type: actionTypes.SAVE_OTHER_INCOME_DATA,
  payload,
});
export const saveOtherIncomeEditData = (payload) => ({
  type: actionTypes.SAVE_OTHER_INCOME_EDIT_DATA,
  payload,
});
export const postOtherIncomeEditData = (payload) => ({
  type: actionTypes.POST_OTHER_INCOME_EDIT_DATA,
  payload,
});
// order payments
export const getOrderPaymentsData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_DATA,
  payload,
});
export const saveOrderPaymentsData = (payload) => ({
  type: actionTypes.SAVE_ORDER_PAYMENTS_DATA,
  payload,
});

export const getOrderPaymentsItemData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_ITEM_DATA,
  payload,
});
export const saveOrderPaymentsItemData = (payload) => ({
  type: actionTypes.SAVE_ORDER_PAYMENTS_ITEM_DATA,
  payload,
});

export const getOrderPaymentsBundleItemData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_BUNDLE_ITEM_DATA,
  payload,
});
export const saveOrderPaymentsBundleItemData = (payload) => ({
  type: actionTypes.SAVE_ORDER_PAYMENTS_BUNDLE_ITEM_DATA,
  payload,
});

export const getOrderPaymentsComponentData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_COMPONENT_DATA,
  payload,
});
export const saveOrderPaymentsComponentData = (payload) => ({
  type: actionTypes.SAVE_ORDER_PAYMENTS_COMPONENT_DATA,
  payload,
});

export const getOrderPaymentsViewBillsData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_VIEW_BILLS_DATA,
  payload,
});
export const saveOrderPaymentsViewBillsData = (payload) => ({
  type: actionTypes.SAVE_ORDER_PAYMENTS_VIEW_BILLS_DATA,
  payload,
});

export const getOrderPaymentsBillsItemData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_BILLS_ITEM_DATA,
  payload,
});

export const getOrderPaymentsBillsComponentData = (payload) => ({
  type: actionTypes.GET_ORDER_PAYMENTS_BILLS_COMPONENT_DATA,
  payload,
});

export const postOrderPaymentsPrintBill = (payload) => ({
  type: actionTypes.POST_ORDER_PAYMENTS_PRINT_BILL,
  payload,
});

// refunds
export const getRefundsData = (payload) => ({
  type: actionTypes.GET_REFUNDS_DATA,
  payload,
});
export const saveRefundsData = (payload) => ({
  type: actionTypes.SAVE_REFUNDS_DATA,
  payload,
});

export const getBillData = (payload) => ({
  type: actionTypes.GET_REFUNDS_BILL_DATA,
  payload,
});
export const saveRefundsBillData = (payload) => ({
  type: actionTypes.SAVE_REFUNDS_BILL_DATA,
  payload,
});

export const getInnerMenuItemsData = (payload) => ({
  type: actionTypes.GET_INNER_MENU_ITEMS_DATA,
  payload,
});
export const saveInnerMenuItemsData = (payload) => ({
  type: actionTypes.SAVE_INNER_MENU_ITEMS_DATA,
  payload,
});

export const getInnerComponentData = (payload) => ({
  type: actionTypes.GET_INNER_COMPONENT_DATA,
  payload,
});
export const saveInnerComponentData = (payload) => ({
  type: actionTypes.SAVE_INNER_COMPONENT_DATA,
  payload,
});

// voids
export const getVoidsData = (payload) => ({
  type: actionTypes.GET_VOIDS_DATA,
  payload,
});
export const saveVoidsData = (payload) => ({
  type: actionTypes.SAVE_VOIDS_DATA,
  payload,
});

// disocunts
export const getDiscountsData = (payload) => ({
  type: actionTypes.GET_DISCOUNTS_DATA,
  payload,
});
export const saveDiscountsData = (payload) => ({
  type: actionTypes.SAVE_DISCOUNTS_DATA,
  payload,
});

// tips
export const getTipsData = (payload) => ({
  type: actionTypes.GET_TIPS_DATA,
  payload,
});
export const saveTipsData = (payload) => ({
  type: actionTypes.SAVE_TIPS_DATA,
  payload,
});

// promotions
export const getPromotionsData = (payload) => ({
  type: actionTypes.GET_PROMOTIONS_DATA,
  payload,
});
export const savePromotionsData = (payload) => ({
  type: actionTypes.SAVE_PROMOTIONS_DATA,
  payload,
});
export const getPromotionsSalesData = (payload) => ({
  type: actionTypes.GET_PROMOTIONS_SALES_DATA,
  payload,
});
export const savePromotionsSalesData = (payload) => ({
  type: actionTypes.SAVE_PROMOTIONS_SALES_DATA,
  payload,
});

// expenses
export const getExpensesData = (payload) => ({
  type: actionTypes.GET_EXPENSES_DATA,
  payload,
});
export const saveExpensesData = (payload) => ({
  type: actionTypes.SAVE_EXPENSES_DATA,
  payload,
});

// payments
export const getPaymentsData = (payload) => ({
  type: actionTypes.GET_PAYMENTS_DATA,
  payload,
});
export const savePaymentsData = (payload) => ({
  type: actionTypes.SAVE_PAYMENTS_DATA,
  payload,
});
export const getAddPaymentsFormData = (payload) => ({
  type: actionTypes.ADD_PAYMENTS_FORM_DATA,
  payload,
});
export const saveAddPaymentsFormData = (payload) => ({
  type: actionTypes.SAVE_ADD_PAYMENTS_FORM_DATA,
  payload,
});
export const postAddPaymentsFormData = (payload) => ({
  type: actionTypes.POST_ADD_PAYMENTS_FORM_DATA,
  payload,
});
export const getExpenseTypeData = (payload) => ({
  type: actionTypes.GET_EXPENSE_TYPE_DATA,
  payload,
});
export const saveExpenseTypeData = (payload) => ({
  type: actionTypes.SAVE_EXPENSE_TYPE_DATA,
  payload,
});

export const getInvoicesData = (payload) => ({
  type: actionTypes.GET_INVOICES_DATA,
  payload,
});
export const saveInvoicesData = (payload) => ({
  type: actionTypes.SAVE_INVOICES_DATA,
  payload,
});

export const getPayTradeLiabilityData = (payload) => ({
  type: actionTypes.GET_PAY_TRADE_LIABILITY_DATA,
  payload,
});
export const savePayTradeLiabilityData = (payload) => ({
  type: actionTypes.SAVE_PAY_TRADE_LIABILITY_DATA,
  payload,
});

export const getPayOtherDebtData = (payload) => ({
  type: actionTypes.GET_PAY_OTHER_DEBT_DATA,
  payload,
});
export const savePayOtherDebtData = (payload) => ({
  type: actionTypes.SAVE_PAY_OTHER_DEBT_DATA,
  payload,
});

export const getBuyAssetData = (payload) => ({
  type: actionTypes.GET_BUY_ASSET_DATA,
  payload,
});
export const saveBuyAssetData = (payload) => ({
  type: actionTypes.SAVE_BUY_ASSET_DATA,
  payload,
});

export const getPaymentAccountData = (payload) => ({
  type: actionTypes.GET_PAYMENT_ACCOUNT_DATA,
  payload,
});
export const savePaymentAccountData = (payload) => ({
  type: actionTypes.SAVE_PAYMENT_ACCOUNT_DATA,
  payload,
});

export const getAddAssetData = (payload) => ({
  type: actionTypes.GET_ADD_ASSET_DATA,
  payload,
});
export const saveAddAssetData = (payload) => ({
  type: actionTypes.SAVE_ADD_ASSET_DATA,
  payload,
});
export const postAddAssetData = (payload) => ({
  type: actionTypes.POST_ADD_ASSET_DATA,
  payload,
});
export const postDeleteAddAssetData = (payload) => ({
  type: actionTypes.POST_DELETE_ADD_ASSET_DATA,
  payload,
});

export const getApLiabilityData = (payload) => ({
  type: actionTypes.GET_AP_LIABILITY_DATA,
  payload,
});
export const saveApLiabilityData = (payload) => ({
  type: actionTypes.SAVE_AP_LIABILITY_DATA,
  payload,
});

export const getViewPaymentData = (payload) => ({
  type: actionTypes.GET_VIEW_PAYMENT_DATA,
  payload,
});
export const saveViewPaymentData = (payload) => ({
  type: actionTypes.SAVE_VIEW_PAYMENT_DATA,
  payload,
});

export const getEditPaymentData = (payload) => ({
  type: actionTypes.GET_EDIT_PAYMENT_DATA,
  payload,
});

export const saveEditPaymentData = (payload) => ({
  type: actionTypes.SAVE_EDIT_PAYMENT_DATA,
  payload,
});

export const postEditPaymentData = (payload) => ({
  type: actionTypes.POST_EDIT_PAYMENT_DATA,
  payload,
});

export const getPendingPaymentsData = (payload) => ({
  type: actionTypes.GET_PENDING_PAYMENTS_DATA,
  payload,
});

export const savePendingPaymentsData = (payload) => ({
  type: actionTypes.SAVE_PENDING_PAYMENTS_DATA,
  payload,
});

export const getApprovedPaymentsData = (payload) => ({
  type: actionTypes.GET_APPROVED_PAYMENTS_DATA,
  payload,
});

export const saveApprovedPaymentsData = (payload) => ({
  type: actionTypes.SAVE_APPROVED_PAYMENTS_DATA,
  payload,
});

export const postApprovedPaymentsData = (payload) => ({
  type: actionTypes.POST_APPROVED_PAYMENTS_DATA,
  payload,
});

export const getSubmittedPaymentsData = (payload) => ({
  type: actionTypes.GET_SUBMITTED_PAYMENTS_DATA,
  payload,
});

export const saveSubmittedPaymentsData = (payload) => ({
  type: actionTypes.SAVE_SUBMITTED_PAYMENTS_DATA,
  payload,
});

export const getRejectedPaymentsData = (payload) => ({
  type: actionTypes.GET_REJECTED_PAYMENTS_DATA,
  payload,
});

export const saveRejectedPaymentsData = (payload) => ({
  type: actionTypes.SAVE_REJECTED_PAYMENTS_DATA,
  payload,
});

export const getFinancePayablesOutstanding = (payload) => ({
  type: actionTypes?.GET_FINANCE_PAYABLES_OUTSTANDING,
  payload,
});

export const getFinanceApCreditNotes = (payload) => ({
  type: actionTypes?.GET_FINANCE_AP_CREDIT_NOTES,
  payload,
});

export const getApCreditNotesOption = (payload) => ({
  type: actionTypes?.GET_AP_CREDIT_NOTES_OPTION,
  payload,
});

export const getApCreditNotesTaxPercentage = (payload) => ({
  type: actionTypes?.GET_AP_CREDIT_NOTES_TAX_PERCENTAGE,
  payload,
});

export const postApCreditNotesData = (payload) => ({
  type: actionTypes?.POST_AP_CREDIT_NOTES_DATA,
  payload,
});

export const getEditApCreditNotesData = (payload) => ({
  type: actionTypes?.GET_EDIT_AP_CREDIT_NOTES_DATA,
  payload,
});

export const postCreditNotesAttachment = (payload) => ({
  type: actionTypes?.POST_CREDI_NOTES_ATTACHMENT,
  payload,
});

export const getFinanceAssets = (payload) => ({
  type: actionTypes?.GET_FINANCE_ASSETS,
  payload,
});

export const downloadFinanceAssets = (payload) => ({
  type: actionTypes?.DOWNLOAD_FINANCE_ASSETS,
  payload,
});

export const downloadFinanceVoucher = (payload) => ({
  type: actionTypes?.DOWNLOAD_FINANCE_VOUCHER,
  payload,
});

export const getFinanceVouchersList = (payload) => ({
  type: actionTypes?.GET_FINANCE_VOUCHERS_LIST,
  payload,
});

export const getFinanceVouchers = (payload) => ({
  type: actionTypes?.GET_FINANCE_VOUCHERS,
  payload,
});

export const getFinanceBalanceToIncome = (payload) => ({
  type: actionTypes?.GET_FINANCE_BALANCE_TO_INCOME,
  payload,
});
